/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import { CommercialOperationDate } from '@price-card/models/commercial-operation-date.model';
import {
  retrieveCommercialOperationDatesFailure,
  retrieveCommercialOperationDatesSuccess,
} from '@store/price-card/commercial-operation-date/commercial-operation-date.slice';

export const retrieveCommercialOperationDatesEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('commercialOperationDates/retrieveCommercialOperationDates'),
    concatMap((_action: Action) =>
      from(dependencies.commercialOperationDateGateway.retrieveAll()).pipe(
        map((commercialOperationDates: CommercialOperationDate[]) => retrieveCommercialOperationDatesSuccess(commercialOperationDates)),
        catchError(() => of(retrieveCommercialOperationDatesFailure('Fail to retrieve price zones'))),
      ),
    ),
  );
